import { SCROLL_OFFSET } from '@constants'
import { useEffect, useRef } from 'react'
export function useScrollOnLoad(dependencies: unknown[]) {
  const scrollableEditorRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (scrollableEditorRef.current) {
      const selectedElement =
        scrollableEditorRef.current.querySelector<HTMLImageElement>('.elElegido')

      if (scrollableEditorRef.current && selectedElement) {
        const offsetTop = selectedElement.offsetTop
        const desiredScrollTop = offsetTop - scrollableEditorRef.current.offsetTop - SCROLL_OFFSET
        scrollableEditorRef.current.scrollTo({
          top: desiredScrollTop,
          behavior: 'smooth',
        })
      }
    }
  }, dependencies)

  return { scrollableEditorRef }
}
